import { Component, OnInit } from '@angular/core';
import { DatastoreService } from '../../services/datastore.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ApiService } from '../../services/jrni/api.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  show: boolean = false;
  showMenu: boolean = false;
  showSubmenu: number = 0;
  displayBanner: any;
  bannerText: any;
  constructor(
    public datastoreService: DatastoreService,
    private departmentService: DepartmentService,
    private apiService: ApiService

  ) { }

  async ngOnInit() {
    // Update current year

    const getHamburgerIcon = () => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('width', '50');
      svg.setAttribute('height', '50');
      svg.setAttribute('viewBox', '0 0 16 16');
      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path'
      );
      path.setAttribute('fillRule', 'evenodd');
      path.setAttribute(
        'd',
        'M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5'
      );
      svg.appendChild(path);
      return svg;
    };

    const getCloseIcon = () => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('width', '50');
      svg.setAttribute('height', '50');
      svg.setAttribute('viewBox', '0 0 16 16');
      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path'
      );
      path.setAttribute(
        'd',
        'M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708'
      );
      svg.appendChild(path);
      return svg;
    };

    // Hamburger menu
    const button: any = document.querySelector('.menu-show');
    if (button) {
      const icon = button.querySelector('i');
      icon.addEventListener('click', () => {
        const menu = document.querySelector('.hamburger-menu');
        icon.textContent = '';
        if (menu.classList.contains('hidden')) {
          icon.appendChild(getCloseIcon());
          button.title = 'Close menu';
          menu.classList.remove('hidden');
        } else {
          icon.appendChild(getHamburgerIcon());
          button.title = 'Open menu';
          menu.classList.add('hidden');
        }
      });
    }

    let parentDepartment = await this.departmentService.getParentDepartment();

    const pId = parentDepartment.id;
    const pClient = parentDepartment.self.split('://')[1].split('.')[0];
    const token: any = await this.apiService.getToken(pClient, pId);
    if (token) {
      environment.clientToken = token.token;
    }
    const config: any = await this.apiService.getConfig(pClient, pId);
    this.datastoreService.config = config;
    console.log("config config", config)
    console.log("config config", config?.betaPhaseBanner?.displayBanner)
    this.displayBanner = config?.betaPhaseBanner?.displayBanner
    if (this.displayBanner) {
      this.bannerText = config.betaPhaseBanner.bannerText
    }
    console.log("displayBanner",this.displayBanner,this.bannerText)

  }

}
